import React from 'react';
import expert_check from '../../../assets/img/expert/expert_check.svg';
import expert_close from '../../../assets/img/expert/expert_close.png';
import expert_03 from '../../../assets/img/expert/expert_03.webp';
import {useNavigate} from 'react-router-dom';
import {OneSubModuleType} from '../../../types/TypesEducation';
type Props = {
	title: string;
	link: string;
	subModules: any;
	textAccess: string;
	textAccessDenied: string;
	textNotAvailable: string;
	textOneMoreTime: string;
};

const EducationModules: React.FC<Props> = ({
	title,
	link,
	subModules,
	textAccess,
	textAccessDenied,
	textNotAvailable,
	textOneMoreTime,
}) => {
	const navigate = useNavigate();

	return (
		<div className="page__modules modules">
			{Boolean(title) && <div className="modules__title">{title}</div>}
			<div className="modules__row">
				{subModules?.map((module: OneSubModuleType, index: number) => {
					return (
						<div key={module.module_id + index} className="modules__column">
							<div className="modules__item item-modules">
								{module.permit && (
									<div className="item-modules__top">
										<div className="item-modules__icon">
											<img src={expert_check} alt="expert_icon" />
										</div>
										<div className="item-modules__percent">
											{module.progress}%
										</div>
									</div>
								)}
								{!module.permit && (
									<div className="item-modules__top">
										<div className="item-modules__icon item-modules__icon-black">
											<img src={expert_close} alt="expert_icon" />
										</div>
										<div className="item-modules__percent item-modules__percent-black">
											{textAccessDenied}
										</div>
									</div>
								)}
								<div className="item-modules__img">
									<img src={module.img ?? expert_03} alt={module.name} />
								</div>
								<div className="item-modules__label">{module.name}</div>
								{module.permit ? (
									<button
										onClick={() =>
											navigate(
												link +
													(Boolean(module.lesson_id)
														? module.lesson_id
														: Boolean(module.module_id)
															? module.module_id
															: module.module_id),
											)
										}
										className="item-modules__btn btn-main"
									>
										{' '}
										{textAccess} {module.progress > 0 ? textOneMoreTime : ''}
									</button>
								) : (
									<button
										className="item-modules__btn btn-main btn-main-dark"
										disabled={true}
									>
										{textNotAvailable ?? textAccessDenied}
									</button>
								)}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default EducationModules;
